import { render, staticRenderFns } from "./ListadoConvenios.vue?vue&type=template&id=19bbad53"
import script from "./ListadoConvenios.vue?vue&type=script&lang=js"
export * from "./ListadoConvenios.vue?vue&type=script&lang=js"
import style0 from "./ListadoConvenios.vue?vue&type=style&index=0&id=19bbad53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports